import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Question from "@/components/ques/Question.vue";
import ExamDoRight from "./components/ExamDoRight.vue";
import ExamIndexBread from "./components/ExamIndexBread.vue";
export default {
  name: "ExamPackageDo",
  components: {
    Question: Question,
    ExamDoRight: ExamDoRight,
    ExamIndexBread: ExamIndexBread
  },
  data: function data() {
    return {
      id: this.$route.query.id,
      package_id: this.$route.query.package_id,
      package_name: this.$route.query.package_name,
      paper_id: this.$route.query.paper_id,
      answer: {},
      current: {},
      storeKey: "exam-seconds",
      scantron: {},
      answerImg: {},
      section: {},
      paper: {},
      scantronQuestions: [],
      index: 1,
      hasScroll: false,
      fixed: 0,
      fixedRight: 0
    };
  },
  computed: {
    style: function style() {
      var style = {};
      style.right = this.fixedRight + "px";

      if (this.fixed == 1) {
        style.position = "fixed";
        style.top = "70px";
      } else if (this.fixed == 2) {
        style.position = "absolute";
        style.bottom = "0";
      }

      return style;
    }
  },
  watch: {
    "current.is_sign": {
      handler: function handler() {
        var _this = this;

        this.scantronQuestions.find(function (q) {
          return q.question_id == _this.current.question_id;
        }).is_sign = this.current.is_sign;
      }
    },
    current: function current() {
      this.initScroll();
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$http.post("/api/app/practice/exam", {
                package_id: this.package_id,
                exam_id: this.paper_id,
                report_id: this.id
              });

            case 2:
              this.paper = _context.sent;
              _context.next = 5;
              return this.getTopicStatus();

            case 5:
              this.$nextTick(function () {
                _this2.$refs.right.init(_this2.index);
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      document.addEventListener("scroll", _this3.setFixed);
      document.addEventListener("resize", _this3.setFixed);
    });
  },
  destroyed: function destroyed() {
    document.removeEventListener("scroll", this.setFixed);
    document.removeEventListener("resize", this.setFixed);
  },
  methods: {
    setFixed: function setFixed() {
      var $ = window.$;
      var scrollTop = $(document.documentElement).scrollTop();

      if (scrollTop > 48) {
        var footerOffset = $("#footerBar").offset();
        var rightHeight = this.$refs.rightWrap.clientHeight;

        if (footerOffset.top - rightHeight - scrollTop < 100) {
          this.fixed = 2;
          this.fixedRight = 0;
        } else {
          this.fixed = 1;
          this.fixedRight = ($(window).width() - 1200) / 2;

          if (this.fixedRight < 0) {
            this.fixedRight = 0;
          }
        }
      } else {
        this.fixed = 0;
      }
    },
    getTopicStatus: function () {
      var _getTopicStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;

        var data, list, answerCount, quesFirst;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$http.post("/api/app/practice/scantron", {
                  report_id: this.id,
                  type: 2
                });

              case 2:
                data = _context2.sent;
                list = [];
                data.data.forEach(function (t) {
                  t.child.forEach(function (ques, index) {
                    list.push(ques);

                    if (index == 0) {
                      _this4.$set(_this4.section, ques.question_id, {
                        name: t.name,
                        introduce: t.introduce
                      });
                    }
                  });
                });
                answerCount = list.filter(function (t) {
                  return t.status == 1 || t.status == 2;
                }).length;

                if (answerCount > 0) {
                  quesFirst = list.find(function (q) {
                    return q.status == 3;
                  });

                  if (quesFirst) {
                    this.index = quesFirst.sort;
                  }
                }

                this.scantron = data;
                this.scantronQuestions = list; // 全部模式

                this.$store.commit("setQuestionMode", data.practise_module); // 当前模式

                this.$store.commit("setQuestionModeSelect", data.mode);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTopicStatus() {
        return _getTopicStatus.apply(this, arguments);
      }

      return getTopicStatus;
    }(),
    addImg: function addImg(ques, path) {
      var images = this.answerImg[ques.question_id] || [];
      images.push(path);
      this.$set(this.answerImg, ques.question_id, images);
    },
    deleteImg: function deleteImg(ques, index) {
      this.answerImg[ques.question_id].splice(index, 1);
    },
    onTopicChange: function onTopicChange(ques) {
      this.hasScroll = false;
      this.scantronQuestions.find(function (q) {
        return q.question_id == ques.question_id;
      }).status = ques.status;

      if (ques.ques_type == 1 || ques.ques_type == 2) {
        this.$set(this.answer, ques.question_id, ques.user_answer);
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        this.$set(this.answer, ques.question_id, ques.user_answer ? ques.user_answer.split(",").map(function (s) {
          return Number(s);
        }) : []);
      } else if (ques.ques_type == 7) {
        this.$set(this.answer, ques.question_id, ques.user_answer ? ques.user_answer.split("@@") : ques.right_answer.map(function () {
          return "";
        }));
      } else if (ques.ques_type == 5) {
        //简答题
        if (ques.user_answer) {
          var user_answer = JSON.parse(ques.user_answer);
          this.$set(this.answer, ques.question_id, user_answer.content);
          this.$set(this.answerImg, ques.question_id, user_answer.images);
        }
      }

      this.$set(this, "current", ques);
    },
    onChange: function onChange(ques) {
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        if (this.answer[ques.question_id]) {
          this.scantronQuestions.find(function (q) {
            return q.question_id == ques.question_id;
          }).status = 1; // examDoRight.vue内部监听状态进行练习模式出答案

          if (this.$store.state.questionModeSelect == 2 && !ques.is_confirm) {
            this.$store.commit("setShowQuestionAnswer", {
              is_confirm: 1,
              get: true
            });
          } else {
            this.$refs.right.navNext();
          }
        }
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        if (this.answer[ques.question_id].length > 0) {
          this.scantronQuestions.find(function (q) {
            return q.question_id == ques.question_id;
          }).status = 1;
        } else {
          this.scantronQuestions.find(function (q) {
            return q.question_id == ques.question_id;
          }).status = 3;
        }
      } else if (ques.ques_type == 7) {
        if (this.answer[ques.question_id].some(Boolean)) {
          this.scantronQuestions.find(function (q) {
            return q.question_id == ques.question_id;
          }).status = 1;
        } else {
          this.scantronQuestions.find(function (q) {
            return q.question_id == ques.question_id;
          }).status = 3;
        }
      } else if (ques.ques_type == 5) {
        //简答题
        if (this.answer[ques.question_id] || (this.answerImg[ques.question_id] || []).length > 0) {
          this.scantronQuestions.find(function (q) {
            return q.question_id == ques.question_id;
          }).status = 1;
        } else {
          this.scantronQuestions.find(function (q) {
            return q.question_id == ques.question_id;
          }).status = 3;
        }
      }
    },
    submit: function submit() {
      this.$router.replace({
        name: "ExamPackageReport",
        query: {
          id: this.$route.query.id,
          package_id: this.package_id,
          package_name: this.package_name,
          paper_id: this.paper_id
        }
      });
    },
    initScroll: function initScroll() {
      var _this5 = this;

      this.$nextTick(function () {
        setTimeout(function () {
          var height = _this5.$pub.getScreenHeight();

          if (document.body.clientHeight > height + 148) {
            _this5.hasScroll = true;
          } else {
            _this5.hasScroll = false;
          }
        }, 0);
      });
    }
  }
};